var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBusstop(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bus_stop",
    "data-name": "bus stop",
    transform: "translate(-510 -234)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Base",
    width: 72,
    height: 72,
    rx: 12,
    transform: "translate(510 234)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("g", {
    id: "bus_stop_icon",
    "data-name": "bus stop icon",
    transform: "translate(522 246)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_50",
    "data-name": "Rectangle 50",
    width: 48,
    height: 48,
    transform: "translate(0 0)",
    fill: "#fff",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_338",
    "data-name": "Group 338",
    transform: "translate(4 9.333)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_50-2",
    "data-name": "Rectangle 50",
    d: "M3.478,1.739A1.741,1.741,0,0,0,1.739,3.478v19.71a1.741,1.741,0,0,0,1.739,1.739H19.71a1.741,1.741,0,0,0,1.739-1.739V3.478A1.741,1.741,0,0,0,19.71,1.739H3.478M3.478,0H19.71a3.478,3.478,0,0,1,3.478,3.478v19.71a3.478,3.478,0,0,1-3.478,3.478H3.478A3.478,3.478,0,0,1,0,23.188V3.478A3.478,3.478,0,0,1,3.478,0Z",
    transform: "translate(13.623 0)",
    fill: "#19bc9c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_5",
    "data-name": "Subtraction 5",
    d: "M1762.217-2507.464v-5.8h-3.479v5.8h3.479m1.738,1.74H1757v-8.117a1.159,1.159,0,0,1,1.158-1.158h4.638a1.159,1.159,0,0,1,1.159,1.158Z",
    transform: "translate(-1753.812 2534.71)",
    fill: "#19bc9c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_53",
    "data-name": "Rectangle 53",
    d: "M1.739,1.739V13.333h19.71V1.739H1.739M0,0H23.188V15.072H0Z",
    transform: "translate(13.623 4.638)",
    fill: "#19bc9c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_37",
    "data-name": "Line 37",
    d: "M.989,12.754H-.75V0H.989Z",
    transform: "translate(25.678 5.217)",
    fill: "#006"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_38",
    "data-name": "Line 38",
    d: "M7.076.989H.12A.87.87,0,1,1,.12-.75H7.076a.87.87,0,0,1,0,1.739Z",
    transform: "translate(21.62 21.909)",
    fill: "#006"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_39",
    "data-name": "Line 39",
    d: "M.12,4.467A.87.87,0,0,1-.75,3.6V.12A.87.87,0,1,1,.989.12V3.6A.87.87,0,0,1,.12,4.467Z",
    transform: "translate(6.547 16.112)",
    fill: "#19bc9c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_40",
    "data-name": "Line 40",
    d: "M.989,3.478H-.75V0H.989Z",
    transform: "translate(16.982 25.507)",
    fill: "#19bc9c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_41",
    "data-name": "Line 41",
    d: "M.989,3.478H-.75V0H.989Z",
    transform: "translate(28.576 25.507)",
    fill: "#19bc9c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_42",
    "data-name": "Line 42",
    d: "M.989,3.478H-.75V0H.989Z",
    transform: "translate(21.62 25.507)",
    fill: "#19bc9c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_43",
    "data-name": "Line 43",
    d: "M.989,3.478H-.75V0H.989Z",
    transform: "translate(33.214 25.507)",
    fill: "#19bc9c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_44",
    "data-name": "Line 44",
    d: "M38.38.989H.12A.87.87,0,1,1,.12-.75H38.38a.87.87,0,0,1,0,1.739Z",
    transform: "translate(0.75 28.866)",
    fill: "#006"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_23",
    "data-name": "Ellipse 23",
    cx: 1.159,
    cy: 1.159,
    r: 1.159,
    transform: "translate(17.681 20.87)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse_23_-_Outline",
    "data-name": "Ellipse 23 - Outline",
    d: "M1.159,0A1.159,1.159,0,1,1,0,1.159,1.159,1.159,0,0,1,1.159,0Z",
    transform: "translate(17.681 20.87)",
    fill: "#19bc9c"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_24",
    "data-name": "Ellipse 24",
    cx: 1.159,
    cy: 1.159,
    r: 1.159,
    transform: "translate(30.435 20.87)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse_24_-_Outline",
    "data-name": "Ellipse 24 - Outline",
    d: "M1.159,0A1.159,1.159,0,1,1,0,1.159,1.159,1.159,0,0,1,1.159,0Z",
    transform: "translate(30.435 20.87)",
    fill: "#19bc9c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse_25",
    "data-name": "Ellipse 25",
    d: "M4.638,1.739a2.9,2.9,0,1,0,2.9,2.9,2.9,2.9,0,0,0-2.9-2.9M4.638,0A4.638,4.638,0,1,1,0,4.638,4.638,4.638,0,0,1,4.638,0Z",
    transform: "translate(2.029 6.957)",
    fill: "#006"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusstop);
export default __webpack_public_path__ + "static/media/busstop.b7fb67b2f8370a322bd5ac2a464a8571.svg";
export { ForwardRef as ReactComponent };